// Thin client for the admin backend (/api/admin/** → the `adminApi` Cloud Function).
// Sends the signed-in admin's Firebase ID token; the function verifies it's the
// administrator before doing anything privileged.
import { fbAuth } from './firebase';

export async function callAdmin<T = unknown>(op: string, body?: unknown): Promise<T> {
  const user = fbAuth.currentUser;
  if (!user) throw new Error('Not signed in.');
  const token = await user.getIdToken();
  const res = await fetch(`/api/admin/${op}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data: any;
  try { data = JSON.parse(text); } catch { data = { ok: false, error: text.slice(0, 200) }; }
  if (!res.ok || !data.ok) throw new Error(data.error || `HTTP ${res.status} — is the admin function deployed?`);
  return data as T;
}
